import styled from 'styled-components'

import Button from 'shared/components/Button'
import Spinner from 'shared/components/Spinner'
import { colors, fonts } from 'shared/lib'
import { getLocaleDateTime } from 'localization/utils/getLocalDate'
import { t } from 'localization'
import { useCheckoutContext } from 'checkout/containers/CheckoutContextProvider'
import { useEffect, useState } from 'react'
import { useGetPromotionQuery } from 'api/promoCodesApi'

const TP = 'checkout.panels.Promotion.PromotionSummary'

export const PromotionSummary = () => {
  const { order, panels, removePromotionRTK } = useCheckoutContext()
  const [skip, setSkip] = useState(false)
  const {
    data: promotion,
    isLoading,
    isSuccess,
  } = useGetPromotionQuery(order?.promoCodeLedgerId, { skip })

  const handleClickRemovePromotion = () => {
    removePromotionRTK(promotion)
  }

  useEffect(() => {
    if (order?.promoCodeLedgerId) {
      setSkip(false)
    }
  }, [order?.promoCodeLedgerId])

  return (
    <Spinner
      showSpinner={isLoading || panels?.promotion?.loading}
      subText={t(`${TP}.spinnerSubText`, 'Please do not close your browser!')}
      text={t(`${TP}.spinnerText`, 'Removing promo...')}
    >
      {isSuccess ? (
        <Promo>
          <TextContainer>
            <Title>{promotion?.title}</Title>
            <BodyText>
              {t(`${TP}.expires`, {
                defaultValue: 'Expires {expiration}',
                expiration: getLocaleDateTime(promotion?.expiration),
              })}
            </BodyText>
          </TextContainer>
          <div>
            <RemoveButton
              buttonType="link"
              dataTestid="removePromoButton"
              onClick={handleClickRemovePromotion}
              qaAttr="removePromoButton"
            >
              {t(`${TP}.remove`, 'Remove')}
            </RemoveButton>
          </div>
        </Promo>
      ) : null}
      <BodyText>
        {t(
          `${TP}.bodyText`,
          'Limit one promotion per transaction. To apply a different promotion, remove the existing one.',
        )}
      </BodyText>
    </Spinner>
  )
}

const Promo = styled.div`
  align-items: center;
  border: 1px solid ${colors.FC2_BLACK};
  display: flex;
  margin-bottom: 20px;
  padding: 20px;
`
const Title = styled.h4`
  ${fonts.SUBTITLE_3}
  margin: 0 0 3px;
`
const TextContainer = styled.div`
  flex: 1;
`
const BodyText = styled.div`
  ${fonts.BODY_TEXT}
  margin: 0;
`
const RemoveButton = styled(Button)`
  font-size: 12px;
  :hover {
    color: ${colors.FC2_BLACK};
  }
`
